export const catalogueLoading =  ({store})  => store.catalogueReducer.loading;

export const catalogueError =  ({store})  => store.catalogueReducer.error;

export const catalogueData =  ({store})  => store.catalogueReducer.data;